import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root',
})
export class WalletHistoryService {
  constructor(private http: HttpClient) {}
  getWallet(type: any, page: any) {
    return this.http
      .get<any>(
        `${environment.api}/api/customer/wallet?type=${type}&page=${page}`
      )
      .pipe(map((data) => data));
  }

  statistics() {
    return this.http
      .get<any>(`${environment.api}/api/customer/wallet/statistics`)
      .pipe(map((data) => data));
  }

  newWithDrawRequest(data: any) {
    return this.http.post<any>(`${environment.api}/api/customer/wallet`, data);
  }

  getHistoryLinks(referral: any) {
    return this.http
      .get<any>(
        `${environment.api}/api/customer/affiliate/links/history?referral=${referral}`
      )
      .pipe(map((data) => data));
  }
}
